import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import Link from '../../../components/Link';
import Confirm from 'react-confirm-bootstrap';
import withStyles from 'isomorphic-style-loader/withStyles';
import { useIntl, FormattedMessage } from 'react-intl';

import CustomPagination from '../../CustomPagination/CustomPagination';
import CommonTable from '../../CommonTable/CommonTable';
import Loader from '../../Loader/Loader';
import history from '../../../core/history';
import messages from '../../../locale/messages';
import { deleteBlogDetails, updateBlogStatus } from '../../../actions/siteadmin/deleteBlogDetails';
import { debounce } from '../../../helpers/debounce';
import { demoRestriction } from '../../../helpers/DemoRestriction/demoRestriction';

import s from './BlogManagement.css';
import bt from '../../../components/commonStyle.css';

function BlogManagement({ setStateVariable = () => { }, currentPage: propCurrentPage = 1, data, refetch, loading }) {
  const intl = useIntl();
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(propCurrentPage);
  const [searchList, setSearchList] = useState('');

  const handleClick = () => {
    history.push('/siteadmin/page/add');
  };

  const paginationData = (page) => {
    setCurrentPage(page);
    refetch({
      currentPage: page,
      searchList
    });
  };

  const handleSearchChange = debounce((value) => {
    setSearchList(value);
    setCurrentPage(1);
    refetch({
      currentPage: 1,
      searchList: value
    });
  }, 250);

  const handleStatusChange = async (id, currentStatus) => {
    const isRestrict = await dispatch(demoRestriction({}));
    if (isRestrict) return;
    await dispatch(updateBlogStatus(id, currentStatus, currentPage));
    refetch({ currentPage });
  };

  const handleDelete = async (id, currentPage) => {
    const pageResults = data?.getBlogDetails?.results || [];
    const updatedPage = currentPage > 1 && pageResults.length === 1 ? currentPage - 1 : currentPage;
    const isRestrict = await dispatch(demoRestriction({}));
    if (isRestrict) return;
    const deleteValue = await dispatch(deleteBlogDetails(id, updatedPage));
    if (deleteValue?.status === 200) {
      setCurrentPage(updatedPage);
      await setStateVariable({ currentPage: updatedPage, searchList });
      refetch({ currentPage: updatedPage, searchList });
    }
  };

  const thead = () => {
    return [
      { data: intl.formatMessage(messages.idLabel) },
      { data: intl.formatMessage(messages.metaTitleLabel) },
      { data: intl.formatMessage(messages.metaDescriptionLabel) },
      { data: intl.formatMessage(messages.pageTitleLabel) },
      { data: intl.formatMessage(messages.pageUrl) },
      { data: intl.formatMessage(messages.footerCategoryLabel) },
      { data: intl.formatMessage(messages.status) },
      { data: intl.formatMessage(messages.preview) },
      { data: intl.formatMessage(messages.editLabel) },
      { data: intl.formatMessage(messages.delete) },
    ];
  };

  const tbody = () => {
    return data?.getBlogDetails?.results?.map((value, key) => ({
      id: key,
      data: [
        { data: value?.id },
        { data: value?.metaTitle },
        { data: value?.metaDescription },
        { data: value?.pageTitle },
        { data: value?.pageUrl },
        { data: value?.footerCategory },
        {
          data: (
            <select
              value={value?.isEnable}
              onChange={(e) => handleStatusChange(value?.id, e.target.value)}
            >
              <option value={true}>{intl.formatMessage(messages.enabledLabel)}</option>
              <option value={false}>{intl.formatMessage(messages.disabledLabel)}</option>
            </select>
          ),
        },
        {
          data: (
            <a href={`/page/${value?.pageUrl}`} target="_blank" rel="noreferrer">
              <FormattedMessage {...messages.preview} />
            </a>
          ),
        },
        {
          data: (
            <Link to={`/siteadmin/edit/page/${value?.id}`}>
              <FormattedMessage {...messages.editLabel} />
            </Link>
          ),
        },
        {
          data: (
            <Confirm
              onConfirm={() => handleDelete(value?.id, currentPage)}
              body={intl.formatMessage(messages.areYouSureDeleteWishList)}
              confirmText={intl.formatMessage(messages.confirmDelete)}
              cancelText={intl.formatMessage(messages.cancel)}
              title={intl.formatMessage(messages.deletingPageDetails)}
            >
              <a href="javascript:void(0)">
                <FormattedMessage {...messages.delete} />
              </a>
            </Confirm>
          ),
        },
      ],
    }));
  };

  const count = data?.getBlogDetails?.count || 0;

  return (
    <div>
      {loading && <div><Loader type={"text"} /></div>}
      {!loading && <div>
        <CommonTable
          thead={thead}
          tbody={tbody}
          isSearch
          isSearchAdd
          handleSearch={(e) => handleSearchChange(e?.target?.value)}
          title={intl.formatMessage(messages.contentManagementLabel)}
          addAction={handleClick}
          redirectionLabel={intl.formatMessage(messages.addPageLabel)}
        />
        {count > 0 && (
          <CustomPagination
            total={count}
            currentPage={currentPage}
            defaultCurrent={1}
            defaultPageSize={10}
            change={paginationData}
            paginationLabel={intl.formatMessage(messages.pagesLabel)}
          />
        )}
      </div>}
    </div>
  );
}

BlogManagement.propTypes = {
  setStateVariable: PropTypes.func,
  currentPage: PropTypes.number
};

export default withStyles(s, bt)(BlogManagement);
